import * as tslib_1 from "tslib";
import styled, { css } from 'styled-components';
import { akColorN20, akColorN30, akColorB50, akColorN300, akFontFamily, } from '@atlaskit/util-shared-styles';
import { borderRadius, size, ellipsis } from '../mixins';
var wrapperPadding = 8;
export var className = 'media-card-frame';
export var cardShadow = "\n  box-shadow: 0 0 1px 0 rgba(23, 43, 77, 0.24);";
function minWidth(_a) {
    var minWidth = _a.minWidth;
    if (minWidth) {
        return "min-width: " + minWidth + "px;";
    }
    else {
        return '';
    }
}
function maxWidth(_a) {
    var maxWidth = _a.maxWidth;
    if (maxWidth) {
        return "max-width: " + maxWidth + "px;";
    }
    else {
        return '';
    }
}
function interactive(_a) {
    var isInteractive = _a.isInteractive;
    if (isInteractive) {
        return "\n      cursor: pointer;\n      &:hover {\n        background-color: " + akColorN30 + ";\n      }\n      &:active {\n        background-color: " + akColorB50 + ";\n      }\n    ";
    }
    else {
        return '';
    }
}
/*

  Conversation confirming widths with @Scotty:

  # (Standalone links/smart-cards with a feature image) OR (Filmstrip links/smart-cards):

    width: 100% => take up the full width of the container
    max-width: 400px; but don't go larger than 400px
    min-width: 240px; but don't go smaller than 240px

      => so they'll all be 400px unless someone resizes the window

  # (Standalone links/smart-cards without a feature image):

    width: 100% => take up the full width of the container
    max-width: 644px; but don't go larger than 664px
    min-width: 240px; but don't go smaller than 240px

      => so they'll all be 664px unless someone resizes the window

 */
var wrapperStyles = css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", " ", " ", " ", " display: inline-flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  font-family: ", ";\n  padding: 0 ", "px ", "px ", "px;\n  width: 100%;\n  user-select: none;\n  background-color: ", ";\n  line-height: initial;\n  transition: background 0.3s;\n"], ["\n  ", " ", " ", " ", " display: inline-flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  font-family: ", ";\n  padding: 0 ", "px ", "px ", "px;\n  width: 100%;\n  user-select: none;\n  background-color: ", ";\n  line-height: initial;\n  transition: background 0.3s;\n"])), borderRadius, minWidth, maxWidth, interactive, akFontFamily, wrapperPadding, wrapperPadding, wrapperPadding, akColorN20);
// export interface ContentProps {
//   maxWidth?: number;
// }
export var LinkWrapper = styled.a(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", " &:hover {\n    text-decoration: none;\n  }\n"], ["\n  ", " &:hover {\n    text-decoration: none;\n  }\n"])), wrapperStyles);
export var Wrapper = styled.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), wrapperStyles);
export var Header = styled.div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  height: 32px;\n  display: flex;\n  align-items: center;\n  color: ", ";\n"], ["\n  height: 32px;\n  display: flex;\n  align-items: center;\n  color: ", ";\n"])), akColorN300);
export var IconWrapper = styled.div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  ", " ", " ", " margin-right: 4px;\n"], ["\n  ", " ", " ",
    " margin-right: 4px;\n"])), borderRadius, size(16), function (_a) {
    var isPlaceholder = _a.isPlaceholder;
    if (isPlaceholder) {
        return "\n      background-color: " + akColorN30 + ";\n    ";
    }
    else {
        return '';
    }
});
export var TextWrapper = styled.div(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  ", " color: ", ";\n  font-size: 12px;\n  line-height: 16px;\n  ", ";\n"], ["\n  ",
    " color: ", ";\n  font-size: 12px;\n  line-height: 16px;\n  ", ";\n"])), function (_a) {
    var isPlaceholder = _a.isPlaceholder;
    if (isPlaceholder) {
        return "\n        " + borderRadius + "\n        width: 125px;\n        height: 12px;\n        background-color: " + akColorN30 + ";\n      ";
    }
    else {
        return '';
    }
}, akColorN300, ellipsis('none'));
export var Content = styled.div(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  position: relative;\n\n  ", " ", " background-color: white;\n  transition: box-shadow 0.3s;\n\n  ", ";\n"], ["\n  position: relative;\n\n  ", " ", " background-color: white;\n  transition: box-shadow 0.3s;\n\n  ",
    ";\n"])), borderRadius, cardShadow, function (_a) {
    var isInteractive = _a.isInteractive;
    if (isInteractive) {
        return "\n          ." + className + ":hover & {\n            box-shadow: 0 4px 8px -2px rgba(23, 43, 77, 0.32),\n              0 0 1px rgba(23, 43, 77, 0.25);\n          }\n        ";
    }
    else {
        return '';
    }
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=styled.js.map